<script lang="ts">
  import createFrameNode from "@shared/common/node/create/frame";
  import createTextNode from "@shared/common/node/create/text";
  import type { ICardWrapperNode } from "@shared/common/node/type";
  import type { ICampaignListDataItem } from "@shared/common/types/data-source";
  import { getStore } from "../../context";
  import Frame from "./frame.svelte";
  import Text from "./text.svelte";
  const { device: deviceNullable } = getStore();

  export let card: ICardWrapperNode["card"];
  export let content: ICampaignListDataItem["content"];
  let device: "MOBILE" | "DESKTOP" = $deviceNullable ?? "MOBILE";

  $: {
    device = $deviceNullable ?? "MOBILE";
  }
</script>

<Frame
  node={createFrameNode({
    maxWidth: card.maxWidth,
    minWidth: card.minWidth,
    padding: card.padding,
    aspectRatio: card.aspectRatio,
    fills: [
      card.gradientPaint ?? {
        type: "SOLID",
        visible: false,
        color: { r: 255, g: 255, b: 255 },
        opacity: 1,
      },
      {
        type: "IMAGE",
        scaleMode: "FILL",
        path: String(content[`${device.toLowerCase()}ThumbnailUrl`]),
        visible: true,
        video: {
          fileName: "",
          originalFileName: "",
          originalFileType: "",
          thumbnailPath: "",
          thumbnailType: "",
        },
        width: {
          value: Number(content[`${device.toLowerCase()}ThumbnailWidth`]),
          unit: "px",
        },
        height: {
          value: Number(content[`${device.toLowerCase()}ThumbnailHeight`]),
          unit: "px",
        },
      },
      {
        type: "SOLID",
        visible: false,
        color: { r: 255, g: 255, b: 255 },
        opacity: 1,
      },
    ],
    primaryAxisAlignItems: "MAX",
  })}
  hideShadow={false}
>
  <Text
    node={createTextNode({
      content: String(content.title),
      fontSize: card.titleFontSize ?? { value: 22, unit: "px" },
      fontName: card.titleFontName ?? {
        family: "PretendardVariable-v1",
        style: "400",
      },
      wordBreak: "KEEP_ALL",
      lineHeight: { value: 1, unit: "" },
      fills: [
        {
          type: "SOLID",
          visible: true,
          color: card.titleFontColor ?? { r: 0, g: 0, b: 0 },
          opacity: 1,
        },
      ],
      padding: {
        top: { value: 0, unit: "px" },
        bottom: { value: 8, unit: "px" },
        left: { value: 0, unit: "px" },
        right: { value: 0, unit: "px" },
      },
    })}
  ></Text>
  <Text
    node={createTextNode({
      content: String(content.description),
      fontSize: card.descriptionFontSize ?? { value: 12, unit: "px" },
      fontName: card.descriptionFontName ?? {
        family: "PretendardVariable-v1",
        style: "400",
      },
      fills: [
        {
          type: "SOLID",
          visible: true,
          color: card.descriptionFontColor ?? { r: 0, g: 0, b: 0 },
          opacity: 1,
        },
      ],
      padding: {
        top: { value: 0, unit: "px" },
        bottom: { value: 0, unit: "px" },
        left: { value: 0, unit: "px" },
        right: { value: 0, unit: "px" },
      },
      type: "TEXT",
    })}
  ></Text>
</Frame>
